import { BreadCrumb } from "primereact/breadcrumb";
import React, { useEffect, useRef, useState } from "react";
import { routes } from "../../../routes";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import EmptyMessage from "../../../components/datatable/EmptyMessage";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import SearchComponent from "../../../components/datatable/SearchComponent";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { ErrorMsg } from "../../../components/includes/styles/Styles";
import { TextInput } from "../../../components/formLibs/FormLibs";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ProgressSpinner } from "primereact/progressspinner";
import ActionBtn from "../../../components/dashboard/btn/ActionBtn";
import TrainingService from "../../../api/TrainingService";
import { InputTextarea } from "primereact/inputtextarea";
import { useNavigate } from "react-router-dom";

const Training = () => {
  const items = [{ label: "Parcours" }];
  const [refresh, setRefresh] = useState(false);
  const [trainings, setTrainings] = useState([]);
  const [training, setTraining] = useState("");
  const [name, setName] = useState("");
  const [duration, setDuration] = useState("");
  const [description, setDescription] = useState("");
  const navigate = useNavigate();
  const [addVisible, setAddVisible] = useState(false);
  const [updateVisible, setUpdateVisible] = useState(false);
  const toast = useRef(null);
  const candidate = {
    icon: "pi pi-lock",
    url: routes.dashboard.trainings.path,
  };
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    //name: { value: null, matchMode: FilterMatchMode.STARTS_WITH }
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const schema = Yup.object({
    name: Yup.string()
      .required("Le nom est obligatoire")
      .min(3, "Trop court")
      .matches(/^([A-Za-z ]*)$/gi, "Uniquement des lettres svp !"),
    duration: Yup.string()
      .required("La durée est obligatoire")
      .min(3, "Trop court"),
    description: Yup.string()
      .required("La description est obligatoire")
      .min(3, "Trop court"),
  }).required();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ resolver: yupResolver(schema) });

  const header = () => {
    return (
      <div className="flex justify-content-between">
        <Button
          color="#fff"
          icon="pi pi-plus"
          label="Ajouter un parcours"
          onClick={() => setAddVisible(true)}
        />
        <SearchComponent
          globalFilterValue={globalFilterValue}
          onGlobalFilterChange={onGlobalFilterChange}
        />
      </div>
    );
  };
  useEffect(() => {
    setLoading(true);
    TrainingService.getAll()
      .then((res) => {
        setTrainings(res.data.trainingPrograms);
        setLoading(false);
      })
      .catch((err) => {});
  }, [refresh]);

  const actionTemplate = (rowData) => {
    return (
      <div className="flex flex-wrap justify-content-start gap-3">
        <ActionBtn
          icon="pi pi-eye"
          severity="primary"
          tooltip="Voir les sites associés"
          handleClick={() =>
            navigate(`/sites-trainings/${rowData.id}/training`)
          }
        />
        <ActionBtn
          icon="pi pi-pencil"
          severity="info"
          tooltip="Modifier"
          handleClick={() => showUpdate(rowData)}
        />
      </div>
    );
  };

  const addTraining = (data) => {
    setLoading(true);
    TrainingService.create(data)
      .then((res) => {
        setLoading(false);
        setAddVisible(false);
        setRefresh(!refresh);
        reset();
        toast.current.show({
          severity: "info",
          summary: "Succèss",
          detail: "Parcours créé avec succès",
          life: 3000,
        });
      })
      .catch((err) => {
        setLoading(false);
        setAddVisible(false);
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: "Erreur lors de la crétaion du parcours",
          life: 3000,
        });
      });
  };

  const showUpdate = (rowData) => {
    console.log("assafroulaye", register);
    setTraining(rowData.id);
    setName(rowData.name);
    setDuration(rowData.duration);
    setDescription(rowData.description);
    setUpdateVisible(true);
  };
  const updateTraining = (data) => {
    setLoading(true);
    TrainingService.update(training, data)
      .then((res) => {
        setLoading(false);
        setUpdateVisible(false);
        reset();
        toast.current.show({
          severity: "info",
          summary: "Succèss",
          detail: "Parcours Modifié avec succès",
          life: 3000,
        });
        setRefresh(!refresh);
      })
      .catch((err) => {});
  };

  return (
    <div className="pl-2 pr-2">
      <Toast ref={toast} />
      <Dialog
        header="Ajouter Parcours"
        visible={addVisible}
        style={{ width: "50vw" }}
        onHide={() => setAddVisible(false)}
      >
        <form className="form" onSubmit={handleSubmit(addTraining)}>
          <div className="form__item">
            <label htmlFor="name">Nom</label>
            <div className="form__item__ic_p">
              <TextInput
                type="text"
                name="name"
                label="name"
                register={register}
              />
            </div>
            <ErrorMsg>{errors?.name?.message}</ErrorMsg>
          </div>
          <div className="form__item">
            <label htmlFor="duration">Durée</label>
            <div className="form__item__ic_p">
              <TextInput
                type="text"
                name="duration"
                label="duration"
                register={register}
              />
            </div>
            <ErrorMsg>{errors?.duration?.message}</ErrorMsg>
          </div>

          <div className="form__item">
            <label htmlFor="description">Description</label>
            <div className="form__item__ic_p">
              <InputTextarea
                id={"description"}
                {...register("description")}
                rows={4}
                //cols={30}
                className="w-full"
              />
            </div>
            <ErrorMsg>{errors?.description?.message}</ErrorMsg>
          </div>
          <div className="form__item">
            <button type="submit">
              Enregistrer{" "}
              <ProgressSpinner
                style={
                  loading
                    ? { width: "20px", height: "20px" }
                    : { width: "0px", height: "0px" }
                }
                strokeWidth="8"
                loading={loading}
              />
            </button>
          </div>
        </form>
      </Dialog>
      <Dialog
        header="Modifier Parcours"
        visible={updateVisible}
        style={{ width: "50vw" }}
        onHide={() => setUpdateVisible(false)}
      >
        <form className="form" onSubmit={handleSubmit(updateTraining)}>
          <div className="form__item">
            <label htmlFor="name">Nom</label>
            <div className="form__item__ic_p">
              <TextInput
                type="text"
                name="name"
                label="name"
                defaultValue={name}
                register={register}
              />
            </div>
            <ErrorMsg>{errors?.name?.message}</ErrorMsg>
          </div>
          <div className="form__item">
            <label htmlFor="duration">Durée</label>
            <div className="form__item__ic_p">
              <TextInput
                type="text"
                name="duration"
                label="duration"
                defaultValue={duration}
                register={register}
              />
            </div>
            <ErrorMsg>{errors?.duration?.message}</ErrorMsg>
          </div>

          <div className="form__item">
            <label htmlFor="description">Description</label>
            <div className="form__item__ic_p">
              <InputTextarea
                id={"description"}
                {...register("description")}
                rows={4}
                //cols={30}
                className="w-full"
                defaultValue={description}
              />
            </div>
            <ErrorMsg>{errors?.description?.message}</ErrorMsg>
          </div>
          <div className="form__item">
            <button type="submit">
              Enregistrer{" "}
              <ProgressSpinner
                style={
                  loading
                    ? { width: "20px", height: "20px" }
                    : { width: "0px", height: "0px" }
                }
                strokeWidth="8"
                loading={loading}
              />
            </button>
          </div>
        </form>
      </Dialog>
      <BreadCrumb model={items} home={candidate} />
      <div className="">
        <DataTable
          value={trainings}
          tableStyle={{ minWidth: "50rem" }}
          paginator
          rows={5}
          rowsPerPageOptions={[5, 10, 25, 50]}
          dataKey="id"
          filters={filters}
          loading={loading}
          //globalFilterFields={["name"]}
          header={header}
          emptyMessage={EmptyMessage}
        >
          <Column field="name" header="Nom" style={{ width: "20%" }}></Column>
          <Column
            field="duration"
            header="Durée"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="description"
            header="Description"
            style={{ width: "40%" }}
          ></Column>
          <Column
            header="Action"
            body={() => "N/A"}
            style={{ width: "30%" }}
          ></Column>
        </DataTable>
      </div>
    </div>
  );
};

export default Training;
